import { z } from 'zod/v4';
import { paymentStatusEnum, paymentProviderEnum } from '../enums/index';

/**
 * Payment filters schema for list endpoint
 */
export const paymentFiltersSchema = z.object({
  page: z.coerce.number()
    .int('Страница должна быть целым числом')
    .min(1, 'Страница должна быть >= 1')
    .default(1),
  limit: z.coerce.number()
    .int('Лимит должен быть целым числом')
    .min(1, 'Лимит должен быть >= 1')
    .max(100, 'Лимит должен быть <= 100')
    .default(20),
  status: paymentStatusEnum.optional(),
  provider: paymentProviderEnum.optional(),
  orderId: z.coerce.number()
    .int('ID заказа должен быть целым числом')
    .positive('ID заказа должен быть положительным')
    .optional(),
  userId: z.coerce.number()
    .int('ID пользователя должен быть целым числом')
    .positive('ID пользователя должен быть положительным')
    .optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  paidAtFrom: z.string().optional(),
  paidAtTo: z.string().optional(),
  amountFrom: z.coerce.number().nonnegative().optional(),
  amountTo: z.coerce.number().nonnegative().optional(),
  currency: z.string().min(1).max(10).optional(),
  hasProof: z.coerce.boolean().optional(),
  providerPaymentId: z.string().min(1).optional(),
  orderStatusConfigId: z.coerce.number().int().positive().optional(),
  search: z.string().min(1).optional(),
  sortBy: z.enum([
    'id',
    'createdAt',
    'updatedAt',
    'paidAt',
    'amount',
    'status',
    'provider',
    'orderId',
    'userId',
  ]).optional(),
  sortOrder: z.enum(['asc', 'desc']).optional(),
});

export type PaymentFiltersDto = z.infer<typeof paymentFiltersSchema>;

/**
 * Payment status enum values
 */
export const updatePaymentStatusSchema = z.object({
  status: paymentStatusEnum,
});

export type PaymentStatusDto = z.infer<typeof updatePaymentStatusSchema>;

/**
 * Payment analytics request schema
 */
export const paymentAnalyticsSchema = z.object({
  startDate: z.string().min(1, 'startDate обязателен'),
  endDate: z.string().min(1, 'endDate обязателен'),
  currency: z.string().optional(),
});

export type PaymentAnalyticsDto = z.infer<typeof paymentAnalyticsSchema>;

/**
 * Multicard Partner-flow: создание платежа по токену карты (без redirect).
 * saveCard передаёт выбор автопродления с чекаута — читается
 * resolveAutoRenewByOrder на бэкенде.
 */
export const createMulticardPaymentSchema = z.object({
  orderId: z.number().int().positive('ID заказа обязателен'),
  cardToken: z.string().min(1, 'Токен карты обязателен'),
  returnUrl: z.string().url('Необходимо указать return URL'),
  saveCard: z.boolean().optional(),
});

export type CreateMulticardPaymentDto = z.infer<typeof createMulticardPaymentSchema>;

/**
 * Multicard Partner-flow: подтверждение платежа (Этап 2 по докам Multicard).
 * Обязателен даже при requiresOtp=false — пустое тело допустимо.
 */
export const confirmMulticardPaymentSchema = z.object({
  otp: z.string().min(1, 'OTP обязателен').optional(),
  debitAvailable: z.boolean().optional(),
});

export type ConfirmMulticardPaymentDto = z.infer<typeof confirmMulticardPaymentSchema>;
